import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ApiAccessTokenComponent} from './crm-token.component';

const routes: Routes = [
  {
    path: '',
    component: ApiAccessTokenComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApiAccessTokenRoutingModule { }
